import {useNavigate, useLoaderData, useParams, redirect} from "react-router-dom";
import HttpRequest from "../../services/Request";
import TournamentComponent from '../../components/Tournament'
import Input from "../../components/ui/Input";
import Select from "../../components/ui/Select";
import Uploader from "../../components/ui/Uploader";
import {useState} from "react";
import Cookies from "js-cookie";
import {Spin} from 'antd';
import {CloseCircleOutlined} from "@ant-design/icons";
import BackButton from "../../components/BackButton";

const EditSupervisor = () => {
    const {tournament, supervisor} = useLoaderData();
    const navigate = useNavigate();
    const params = useParams();
    const [loading, setLoading] = useState(false)

    const [name, setName] = useState(supervisor.name)
    const [lastname, setLastname] = useState(supervisor.lastname)
    const [mobile, setMobile] = useState(supervisor.mobile)
    const [fatherName, setFatherName] = useState(supervisor.father_name || '')
    const [idNumber, setIdNumber] = useState(supervisor.id_number || '')
    const [nationalCode, setNationalCode] = useState(supervisor.national_code || '')
    const [birthday, setBirthday] = useState(supervisor.birthday || '')
    const [city, setCity] = useState(supervisor.city || '')
    const [workExperience, setWorkExperience] = useState(supervisor.work_experience || '')
    const [email, setEmail] = useState(supervisor.email || '')
    const [gender, setGender] = useState(supervisor.gender === 'آقا' ? 'man' : (supervisor.gender || ''))
    const [height, setHeight] = useState(supervisor.height || '')
    const [weight, setWeight] = useState(supervisor.weight || '')
    const [educationLevel, setEducationLevel] = useState(() => {
        const level = supervisor.education_level || '';
        const map = {'دیپلم': 'd1', 'کارشناسی': 'd2', 'کارشناسی ارشد': 'd3', 'دکترا': 'd4'};
        return map[level] || level;
    })
    const [fieldOfStudy, setFieldOfStudy] = useState(supervisor.field_of_study || '')
    const [image, setImage] = useState(null)
    const [certificates, setCertificates] = useState(null)
    const [insuranceHistory, setInsuranceHistory] = useState(null)
    const [lastImage, setLastImage] = useState(supervisor.image)
    const [lastCertificates, setLastCertificates] = useState(supervisor.certificates)
    const [lastInsuranceHistory, setLastInsuranceHistory] = useState(supervisor.insurance_history)

    async function submitFormHandler() {
        setLoading(true)
        let data = new FormData();

        data.append('name', name);
        data.append('lastname', lastname);
        data.append('mobile', mobile);
        data.append('father_name', fatherName);
        data.append('id_number', idNumber);
        data.append('national_code', nationalCode);
        data.append('birthday', birthday);
        data.append('city', city);
        data.append('work_experience', workExperience);
        data.append('email', email);
        data.append('gender', gender);
        data.append('height', height);
        data.append('weight', weight);
        data.append('education_level', educationLevel);
        data.append('field_of_study', fieldOfStudy);
        if (certificates != null) data.append('certificates', certificates);
        if (insuranceHistory != null) data.append('insurance_history', insuranceHistory);
        if (image != null) data.append('image', image);

        const url = `${process.env.REACT_APP_DOMAIN}/tournament/${params.id}/hse-manager/teams/${params.team_id}/supervisor/update`;
        await HttpRequest(url, (res) => {
            navigate(`/tournament/${params.id}/hse-manager/teams`)
        }, 'post', data)
        setLoading(false)
    }

    return <div>
        <BackButton src={`/tournament/${params.id}/hse-manager/teams`}/>
        <div className="flex items-center">
            <TournamentComponent tournament={tournament}/>
        </div>
        <div className="flex items-center mt-2">
            <div className="flex flex-wrap w-[97%] md:w-[90%] rounded-[15px] mx-auto mt-1 md:mt-0 md:mb-2 p-2 py-5">
                <div className="w-[80%] md:w-[27%] md:mt-5 text-center p-3 mx-auto shadow mt-3 bg-gray2 text-orange">
                    <img src="/icons/icon-4.png" className="inline me-3 w-[25px] h-[25px]"/>
                    ویرایش سرپرست — {supervisor.name} {supervisor.lastname}
                </div>
            </div>
        </div>
        <div className="flex items-center mt-2">
            <div className="flex flex-wrap w-[97%] md:w-[90%] rounded-[15px] mx-auto mt-1 md:mt-0 md:mb-2 bg-white p-2 py-5">
                <Input title="نام" changeValueHandler={setName} value={name}
                       placeholder="نام سرپرست را وارد کنید"/>
                <Input title="نام خانوادگی" changeValueHandler={setLastname} value={lastname}
                       placeholder="نام خانوادگی سرپرست را وارد کنید"/>
                <Input title="شماره موبایل" changeValueHandler={setMobile} value={mobile}
                       placeholder="09125268579 به عنوان مثال"/>
                <Input title="نام پدر" changeValueHandler={setFatherName} value={fatherName} placeholder=""/>
                <Input title="کد ملی" changeValueHandler={setNationalCode} value={nationalCode} placeholder=""/>
                <Input title="شماره شناسنامه" changeValueHandler={setIdNumber} value={idNumber} placeholder=""/>
                <Input title="تاریخ تولد" changeValueHandler={setBirthday} value={birthday}
                       placeholder="1369/02/02"/>
                <Input title="محل صدور شناسنامه" changeValueHandler={setCity} value={city} placeholder=""/>
                <Input title="سابقه کار(سال)" changeValueHandler={setWorkExperience} value={workExperience}
                       placeholder="میزان سابقه کار را به سال وارد کنید"/>
                <Input title="ایمیل" changeValueHandler={setEmail} value={email} placeholder=""/>
                <Select title="جنسیت" changeValueHandler={setGender} value={gender} placeholder="انتخاب کنید"
                        options={[
                            {value: 'man', label: 'آقا'},
                            {value: 'woman', label: 'خانم'}
                        ]}/>
                <Input title="قد" changeValueHandler={setHeight} value={height} placeholder=""/>
                <Input title="وزن" changeValueHandler={setWeight} value={weight} placeholder=""/>
                <Select title="مقطع تحصیلی" changeValueHandler={setEducationLevel} value={educationLevel}
                        placeholder="انتخاب کنید" options={[
                    {value: 'd1', label: 'دیپلم'},
                    {value: 'd2', label: 'کارشناسی'},
                    {value: 'd3', label: 'کارشناسی ارشد'},
                    {value: 'd4', label: 'دکترا'}
                ]}/>
                <Input title="رشته تحصیلی" changeValueHandler={setFieldOfStudy} value={fieldOfStudy}
                       placeholder=""/>

                {lastInsuranceHistory ?
                    <div className={`w-[90%] md:w-[30%] mb-7 mx-auto`}>
                        <p className={`pr-10 text-orange`}>سابقه بیمه و تاییدیه مدیر HSE</p>
                        <div className={`text-center`}>
                            <CloseCircleOutlined onClick={() => setLastInsuranceHistory(null)}
                                                 className={`text-[2.5em] bg-white rounded-full p-3`}/>
                        </div>
                        <div className={`text-center mt-3`}>
                            <a href={lastInsuranceHistory} target={`_blank`}
                               className={`block bg-gray2 rounded mt-2 px-3 text-white text-lg text-center py-5`}>
                                دانلود فایل
                            </a>
                        </div>
                    </div>
                    :
                    <Uploader changeValueHandler={setInsuranceHistory} value={insuranceHistory?.name}
                              title="سابقه بیمه و تاییدیه مدیر HSE (حداکثر 200k)"/>
                }

                {lastCertificates ?
                    <div className={`w-[90%] md:w-[30%] mb-7 mx-auto`}>
                        <p className={`pr-10 text-orange`}>گواهینامه ها(فایل zip,rar)</p>
                        <div className={`text-center`}>
                            <CloseCircleOutlined onClick={() => setLastCertificates(null)}
                                                 className={`text-[2.5em] bg-white rounded-full p-3`}/>
                        </div>
                        <div className={`text-center mt-3`}>
                            <a href={lastCertificates} target={`_blank`}
                               className={`block bg-gray2 rounded mt-2 px-3 text-white text-lg text-center py-5`}>
                                دانلود فایل فشرده
                            </a>
                        </div>
                    </div> : <Uploader changeValueHandler={setCertificates} value={certificates?.name}
                                       title="گواهینامه ها(فایل zip,rar حداکثر 500 k)"/>
                }

                {lastImage ?
                    <div className={`w-[90%] md:w-[30%] mb-7 mx-auto relative`}>
                        <p className={`pr-10 text-orange`}>عکس 3*4</p>
                        <img src={lastImage}/>
                        <CloseCircleOutlined onClick={() => setLastImage(null)}
                                             className={`absolute text-[2.5em] shadow bg-white opacity-75 rounded-full p-5 top-[50%] left-[50%] translate-y-[-50%] translate-x-[-50%] z-2`}/>
                    </div>
                    :
                    <Uploader changeValueHandler={setImage} value={image?.name}
                              title="عکس 3*4 (حداکثر 100 k)"/>
                }

                <div className={`w-[90%] md:w-[30%] mx-auto text-center`}>
                    <button onClick={submitFormHandler} disabled={loading}
                            className={`bg-gray2 text-center rounded py-3 w-[60%] text-white`}>
                        {loading ? <Spin/> : 'ثبت تغییرات'}
                    </button>
                </div>
            </div>
        </div>
    </div>
}

export default EditSupervisor;

export async function EditSupervisorLoader({params}) {
    let data = []
    try {
        await HttpRequest(`${process.env.REACT_APP_DOMAIN}/tournament/${params.id}/hse-manager/teams/${params.team_id}/supervisor`, (res) => {
            data = res.data;
        }, 'get', [], (err) => {
            let error = new Error();
            error.status = err.response.status
            throw error
        })
    } catch (err) {
        if (err.status === 401) {
            Cookies.remove('access_token')
            return redirect('/login')
        }
    }
    return data;
}
